module.exports = __webpack_public_path__ + "img/brand(14).2d209c6b.png";